/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsMatchTimelineEventDtoSchema } from "./matchTimelineEventDtoSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsMatchGameTimelineDtoSchema = z.object({
  gameId: z.optional(z.int()),
  get events() {
    return z.array(goodLuckCoreDTOsMatchTimelineEventDtoSchema).nullish();
  },
});
